import { api } from './api';
import type {
  ReferralOverview,
  ReferralOverviewParams,
  ReferralUsersParams,
  ReferralUserDetail,
  InfluencerCodesParams,
  InfluencerCodeDetail,
  CreateInfluencerCodeRequest,
  UpdateInfluencerCodeRequest,
  ActivityParams,
  UsersResponse,
  ActivityResponse,
  InfluencerCodesResponse,
  PromoCodesParams,
  PromoCodesResponse,
  PromoCodeItem,
  CreatePromoCodeRequest,
  CreatePromoCodeResponse,
  PromoCodeRedemptionsResponse,
} from '../types/referrals';

const BASE_PATH = '/admin/referrals';
const PROMO_PATH = '/admin/promo-codes';

export const getOverview = async (params?: ReferralOverviewParams): Promise<ReferralOverview> => {
  const response = await api.get(`${BASE_PATH}/overview`, { params });
  return response.data;
};

export const getUsers = async (params: ReferralUsersParams): Promise<UsersResponse> => {
  const response = await api.get(`${BASE_PATH}/users`, { params });
  return response.data;
};

export const getUserDetail = async (userId: number): Promise<ReferralUserDetail> => {
  const response = await api.get(`${BASE_PATH}/users/${userId}`);
  return response.data;
};

export const getInfluencerCodes = async (params: InfluencerCodesParams): Promise<InfluencerCodesResponse> => {
  const response = await api.get(`${BASE_PATH}/influencer-codes`, { params });
  return response.data;
};

export const createInfluencerCode = async (body: CreateInfluencerCodeRequest): Promise<InfluencerCodeDetail> => {
  const response = await api.post(`${BASE_PATH}/influencer-codes`, body);
  return response.data;
};

export const getInfluencerCodeDetail = async (codeId: number): Promise<InfluencerCodeDetail> => {
  const response = await api.get(`${BASE_PATH}/influencer-codes/${codeId}`);
  return response.data;
};

export const updateInfluencerCode = async (codeId: number, body: UpdateInfluencerCodeRequest): Promise<InfluencerCodeDetail> => {
  const response = await api.patch(`${BASE_PATH}/influencer-codes/${codeId}`, body);
  return response.data;
};

export const deactivateInfluencerCode = async (codeId: number): Promise<void> => {
  await api.delete(`${BASE_PATH}/influencer-codes/${codeId}`);
};

export const getActivity = async (params: ActivityParams): Promise<ActivityResponse> => {
  const response = await api.get(`${BASE_PATH}/activity`, { params });
  return response.data;
};

// Promo codes

export const getPromoCodes = async (params: PromoCodesParams): Promise<PromoCodesResponse> => {
  const response = await api.get(PROMO_PATH, { params });
  return response.data;
};

export const createPromoCode = async (body: CreatePromoCodeRequest): Promise<CreatePromoCodeResponse> => {
  const response = await api.post(PROMO_PATH, body);
  return response.data;
};

export const getPromoCodeRedemptions = async (
  promoCodeId: number,
  params?: { limit?: number; offset?: number },
): Promise<PromoCodeRedemptionsResponse> => {
  const response = await api.get(`${PROMO_PATH}/${promoCodeId}/redemptions`, { params });
  return response.data;
};

export const deactivatePromoCode = async (promoCodeId: number): Promise<PromoCodeItem> => {
  const response = await api.post(`${PROMO_PATH}/${promoCodeId}/deactivate`);
  return response.data;
};

export const reactivatePromoCode = async (promoCodeId: number): Promise<PromoCodeItem> => {
  const response = await api.post(`${PROMO_PATH}/${promoCodeId}/reactivate`);
  return response.data;
};

export const referralsService = {
  getOverview,
  getUsers,
  getUserDetail,
  getInfluencerCodes,
  createInfluencerCode,
  getInfluencerCodeDetail,
  updateInfluencerCode,
  deactivateInfluencerCode,
  getActivity,
  getPromoCodes,
  createPromoCode,
  getPromoCodeRedemptions,
  deactivatePromoCode,
  reactivatePromoCode,
};

export default referralsService;
